export enum UserRoleMetadaInsuranceNew {
  TIPPER = 'TIP',
  SELLER = 'DPZ',
  NONE = 'NONE',
}

export enum InsurerRoleMetadaInsuranceNew {
  TIPPER = 'TIP',
  SELLER = 'DPZ',
}

export enum InsuranceTypeMetadaInsuranceNew {
  POV = 'POV',
  POVHAV = 'POV/HAV',
}

export type GetInsuranceOfferApiResponseMetadaInsuranceNew =
  | /** status 200 Standard response */ ({
      insurance?: InsuranceOfferMetadaInsuranceNew | null;
      userRole?: UserRoleMetadaInsuranceNew | null;
    } | null)
  | /** status 204 Standard response */ undefined;

export type InsuranceOfferMetadaInsuranceNew = {
  type?: InsuranceTypeMetadaInsuranceNew | null;
  insurance?: number | null;
  insuranceWithDiscount?: number | null;
  commissionYearly?: number | null;
  commissionFull?: number | null;
};

export type InsuranceVehicleMetadaInsuranceNew = {
  sellingPrice?: string;
  firstRegistrationOnDay?: number;
  firstRegistrationOnMonth?: number;
  firstRegistrationOnYear?: number;
  engineVolume?: number | null;
  power?: number | null;
  make?: string | null;
  type?: string;
  fuelType?: string | null;
  mileage?: number | null;
  weight?: number | null;
  vin?: string;
  modelFamily?: string | null;
  registrationPlate?: string | null;
  vtpNumber?: string | null;
  seatCount?: number | null;
};

export type InsurancePersonMetadaInsuranceNew = {
  firstName?: string | null;
  lastName?: string | null;
  titleBefore?: string | null;
  companyName?: string | null;
  customerDiscriminator?: string | null;
  selfEmployed?: boolean | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  postalCode?: string | null;
  registrationNumber?: string | null;
  personalIdentifier?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
};

export type GetInsuranceOfferApiArgMetadaInsuranceNew = {
  body: {
    tenantId?: string;
    insurerNumber?: string;
    vehicle?: InsuranceVehicleMetadaInsuranceNew | null;
  } | null;
};

export type GetInsuranceComparisonUrlApiResponseMetadaInsuranceNew =
  | /** status 200 Standard response */ ({
      url?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;

export type GetInsuranceComparisonUrlApiArgMetadaInsuranceNew = {
  body: {
    tenantId?: string;
    insurerNumber: string;
    insuranceDraftId?: string | null;
    person?: InsurancePersonMetadaInsuranceNew | null;
    vehicle?: InsuranceVehicleMetadaInsuranceNew | null;
  } | null;
};

export type PostCustomerTipApiArgMetadaInsuranceNew = {
  body: {
    tenantId?: string;
    insurerNumber: string;
    insuranceDraftId?: string | null;
    person?: InsurancePersonMetadaInsuranceNew | null;
    vehicle?: InsuranceVehicleMetadaInsuranceNew | null;
  } | null;
};

export type PostMailApiArgMetadaInsuranceNew = {
  body: {
    tenantId: string;
    tenantName: string;
    userName: string;
    phoneNumber: string;
    email: string;
    roleToApply: InsurerRoleMetadaInsuranceNew;
  } | null;
};

export type InsurancePersonV2MetadaInsuranceNew = {
  firstName?: string | null;
  lastName?: string | null;
  titleBefore?: string | null;
  companyName?: string | null;
  customerDiscriminator?: string | null;
  selfEmployed?: boolean | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  postalCode?: string | null;
  registrationNumber?: string | null;
  personalIdentifier?: string | null;
  email?: string | null;
  phoneNumber?: string | null;
};

export type InsuranceVehicleV2MetadaInsuranceNew = {
  sellingPrice: string;
  type: string;
  engineVolume?: number | null;
  power?: number | null;
  firstRegistrationOnDay: string;
  firstRegistrationOnMonth: string;
  firstRegistrationOnYear: string;
  fuelType?: string | null;
  mileage?: number | null;
  weight?: number | null;
  seatCount?: number | null;
  vin: string;
  registrationPlate?: string | null;
  vtpNumber?: string | null;
  make?: string | null;
  modelFamily?: string | null;
};

export type CarkPostInsuranceDraftApiResponseMetadaInsuranceNew =
  | /** status 200 Standard response */ ({
      url?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type CarkPostInsuranceDraftApiArgMetadaInsuranceNew = {
  body: {
    insuranceDraftId: string;
    person?: InsurancePersonV2MetadaInsuranceNew | null;
    vehicle?: InsuranceVehicleV2MetadaInsuranceNew | null;
    tenantId?: string | null;
    insurerNumber: string;
  } | null;
};

export type CarkPostTipApiResponseMetadaInsuranceNew =
  | /** status 200 Standard response */ ({
      url?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;

export type CarkPostTipApiArgMetadaInsuranceNew = {
  body: {
    insuranceDraftId: string;
    person?: InsurancePersonV2MetadaInsuranceNew | null;
    vehicle?: InsuranceVehicleV2MetadaInsuranceNew | null;
    tenantId?: string | null;
    insurerNumber: string;
  } | null;
};
